import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div
      className="flex min-h-screen items-center justify-center px-4"
      style={{ background: 'var(--base)' }}
    >
      {/* Grain overlay */}
      <div className="grain" />

      {/* Ambient glows */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div
          className="absolute left-1/2 top-1/4 h-[400px] w-[400px] -translate-x-1/2 rounded-full blur-[80px]"
          style={{ background: 'radial-gradient(circle, var(--accent-glow), transparent 60%)' }}
        />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 flex flex-col items-center gap-3">
          <div
            className="flex h-14 w-14 items-center justify-center rounded-2xl shadow-lg"
            style={{
              background: 'linear-gradient(135deg, var(--accent), var(--accent-deep))',
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <div className="text-center">
            <h1 className="display-font text-2xl font-semibold" style={{ color: 'var(--ink)' }}>
              HelpDesk
            </h1>
            <p className="mt-1 text-sm" style={{ color: 'var(--muted)' }}>
              Support Portal
            </p>
          </div>
        </div>

        {/* Auth card */}
        <div
          className="rounded-[20px] border p-8 shadow-sm"
          style={{
            borderColor: 'var(--border)',
            background: 'var(--surface)',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
